import request from './request'

export function listInventoryQuantity(data) {
  return request.post('/inventory/quantities/list', data)
}

export function listStockWarning(data) {
  return request.post('/inventory/quantities/warning-list', data)
}
